exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".documentation-services-page .content .section-header{display:-webkit-box;display:-ms-flexbox;display:flex}.documentation-services-page .content .section-header>div{-webkit-box-flex:50%;-ms-flex:50%;flex:50%}.documentation-services-page .content .section-header>div:last-child{text-align:right}.documentation-services-page .content .header-filter-components{margin-top:10px}.documentation-services-page .content .list-items{margin-top:50px}", ""]);

// exports
